
var featuredMetaData = $("input[name='featuredMetaData']").val();
var data = {
    'action': 'dwd_featured_map',
    'featuredMetaData': featuredMetaData,
};
$.ajax({
    url: dwd_object.ajaxurl,
    data: data,
    type: 'POST',
    success: (response) => {
        if (response.status == 'stateInUS'){
            //State found in US
            $('.state-in-us').removeClass('d-none');
            $('.featured-map .featured-map__img').html(response.image);
            $('.featured-map .state__name').html(response.title);
            $('.featured-map .state__url').html(response.permalink);
            $('.featured-map .state__description').html(response.excerpt);
        }else if (response.status == 'noStateDataFoundInUS') {
            //state not found in US
            $('.no-state-data-found-in-US').removeClass('d-none');
        }else if (response.status == 'countryExceptUS'){
            //countryExceptUS
            $('.country-except-US').removeClass('d-none');
        }
    },
});